module.exports = __webpack_public_path__ + "static/img/new2-CpdygOmA.fe22af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new2-CpdygOmA.png
// module id = 3wOG
// module chunks = 16